module.exports = __webpack_public_path__ + "img/2.25c307ae.jpg";